import clsx from 'clsx'

import { contentPageStore } from 'entities/excursions/content-page/model/content-page-store'

import { getCleanHTML } from 'shared/lib/getCleanHTML'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

const ContentPage = () => {
  const currentContent = contentPageStore.getContentPage()

  return (
    <div className="container">
      {!currentContent ? (
        <Loader
          type="excursions"
          marginTop={200}
        />
      ) : (
        <>
          <HeaderGoBack
            title={currentContent.title}
            buttonWhite
          />
          <div className={s.content}>
            <Paper>
              <div
                className={clsx(s.text, 'regular-14')}
                dangerouslySetInnerHTML={{
                  __html: getCleanHTML(currentContent.content || ''),
                }}
              />
            </Paper>
          </div>
        </>
      )}
    </div>
  )
}

export default ContentPage
